import { forwardRef, ForwardedRef, ReactNode, useEffect, type MutableRefObject } from "react";
import { Popover as PopoverSuite, PopoverProps, Whisper } from "rsuite";
import { OverlayTriggerHandle, OverlayTriggerProps } from "rsuite/esm/internals/Overlay/OverlayTrigger";
interface DefaultPopoverProps extends PopoverProps {
  content: ReactNode;
}
type PopoverType = {
  whisper: OverlayTriggerProps["children"];
  children: ReactNode;
  placement: OverlayTriggerProps["placement"];
  classNames?: string[];
  trigger?: OverlayTriggerProps["trigger"];
  onPopoverClose?: () => void;
};
const DefaultPopover = forwardRef(({
  content,
  ...props
}: DefaultPopoverProps, ref: ForwardedRef<HTMLDivElement>) => {
  return <PopoverSuite visible={false} arrow={false} ref={ref} {...props}>
        {content}
      </PopoverSuite>;
});
const Popover = forwardRef(({
  placement,
  children,
  whisper,
  classNames = [],
  trigger = "click"
}: PopoverType, ref: ForwardedRef<OverlayTriggerHandle>) => {
  function handleOutsideClick(event: MouseEvent) {
    if (trigger === "none") {
      const typedRef = ref as MutableRefObject<OverlayTriggerHandle>;
      if (typedRef.current && !typedRef.current.root?.contains(event.target as Node)) {
        typedRef.current.close();
      }
    }
  }
  useEffect(() => {
    window.addEventListener("click", handleOutsideClick);
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  return <Whisper className={classNames.join(",")} ref={ref} rootClose trigger={trigger} placement={placement} controlId={`control-id-${placement}`} speaker={<DefaultPopover content={children} />}>
        {whisper}
      </Whisper>;
});
export default Popover;